import React from 'react';
import {inject} from 'mobx-react';
import {observe} from 'mobx'
import PrivateRoutes from './private';
import PublicRotes from './public';
import InvalidUser from './invalid_user';


@inject('userStore')
export default class Routing extends React.Component {

  state = {routers: <PublicRotes/>};

  componentWillMount(){
    this.props.userStore.initUser();
    this.initUser();
    this.listener = observe(this.props.userStore, 'user', () => {
      this.initUser();
    });
  }

  initUser = () => {
    let routers = this.props.userStore.user ? <PrivateRoutes/> : <PublicRotes/>;
    this.setState({routers: routers});
  };

  componentWillUnmount(){
    this.listener();
  }

  // getPrivateRoutes = () => {
  //   return this.props.userStore.user.valid_profile ? <PrivateRoutes/> : <InvalidUser/>
  // };

  render() {
    return(
      <div className="wrapper">
        {this.state.routers}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/index.js